const searchClient = algoliasearch(
  'FUU329X6JW',
  'e18adafcb23fc1cd50cca44e0d221c51'
);

const search = instantsearch({
  indexName: 'parts_and_manuals_shopify',
  searchClient,
  routing: true,
  searchFunction(helper) {
    const container = document.querySelector('#hits');
    container.style.display = helper.state.query === '' ? 'none' : '';
    helper.search();
  }  
});

search.addWidgets([
  instantsearch.widgets.configure({
    hitsPerPage: 10,
  }),
  instantsearch.widgets.searchBox({
    container: '#search-box',
    placeholder: 'Enter model number or fan name',
    id: 'PartsSearch',
  }),
	instantsearch.widgets.infiniteHits({
	  container: '#hits',
      escapeHTML: false,
	  templates: {
	    empty: `<div class="no-part-results">
                    <h4>
					We're Sorry! We can't seem to find any products that match your search. <br>
                    Looking for an owner’s manual or parts? <br>
                    Need assistance? <u><a href="https://support.hunterfan.com">Contact Us</a></u>.
              		</h4>
				</div>
        `,
		item: `
			<div class="part-result {{productType}}">
				<div class="part-result--header">
					<div class="img-wrap">
						<img src="{{modelImage}}" alt="part image">
                    </div>
                    <div class="info-wrap">
						<h2><a href="{{modelUrl}}" style="{{modelUrlStyle}}">{{modelName}}</a></h2>
						<p>Model#:{{modelNumber}}</p>
                    </div>
				</div>
                <h3 class="result-header">Manuals</h3>
				<div class="part-result--manuals">
					<div class="manuals-wrap">					
						{{{manuals}}}
                    </div>
				</div>
                <h3 class="result-header">Replacement Parts</h3>
				<div class="part-result--parts">
				{{#parts}}					
                    <div class="part-result--part">
                      <div class="img-wrap">
                          <img src="{{partImage}}" alt="part image">
                      </div>
                      <div class="info-wrap">
                          <h4><a href="{{partUrl}}">{{partName}}</a></h4>
                          <p>Part #: {{partIdentifier}}</p>
                      </div>
                    </div>
				{{/parts}}
				</div>
			</div>
		`,
	  },
	})
]);


search.start();